import { render } from "./ConfirmGoldUsage.vue?vue&type=template&id=071db30a"
import script from "./ConfirmGoldUsage.vue?vue&type=script&lang=js"
export * from "./ConfirmGoldUsage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/ConfirmGoldUsage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "071db30a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('071db30a', __exports__)) {
    api.reload('071db30a', __exports__)
  }
  
  module.hot.accept("./ConfirmGoldUsage.vue?vue&type=template&id=071db30a", () => {
    api.rerender('071db30a', render)
  })

}


export default __exports__